import { render, staticRenderFns } from "./system_list_m.vue?vue&type=template&id=70b1cbe0&scoped=true&"
import script from "./system_list_m.vue?vue&type=script&lang=js&"
export * from "./system_list_m.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b1cbe0",
  null
  
)

export default component.exports